import React,{useMemo,useContext} from "react";

import "./EUMRVPortStays.scss";

import {
	DerogationCCSandCCUColumns,
	EUMRV_PORTSTAYS_HEADERS,
	ETS_COLUMN_KEYS,
	MRV_COLUMN_KEYS
} from "../../../../../../constants/CustomTableHeaders";
import CustomTable from "../../../../../../common/customTable/CustomTable";
import { FeatureType } from "../../../../../../constants/FeatureToggles";
import { ClaimsContext } from "../../../../../../services/ClaimsService";

const DerogationCCSandCCU = ({ data }) => {
	
	const columnsData = (() => {
		const idsToExclude = MRV_COLUMN_KEYS;
		return DerogationCCSandCCUColumns.filter((col) => !idsToExclude.includes(col.accessorKey));
	})();
	return (
		<div className="mt-4 eu_mrv_ps">
			<CustomTable
				columnsData={columnsData}
				renderTableData={data || []}
				customProps={{
					header: EUMRV_PORTSTAYS_HEADERS.CCS_CCU,
					enableSort: false,
					tableName: "emissions-report",
					maxHeight: "30vh",
				}}
			/>
		</div>
	);
};

export default DerogationCCSandCCU;
